import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Injector, AfterViewInit } from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { tap, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductApprovalOrRejectModalComponent } from '../product-approval-or-reject-modal/product-approval-or-reject-modal.component';
import { OrderServiceProxy, OrderApprovedDto, OrderProductTaskDto } from '../../../../../../../shared/service-proxies/service-proxies';
import { ImageModalComponent } from '../../wizards/step3/image-modal/image-modal.component';
import { AppComponentBase } from '../../../../../../../shared/app-component-base';
import { CustomLocalizationService } from '../../../utility/customLocalization.service';
import { ProductHistoryViewInformationComponent } from '../product-history-view-information/product-history-view-information.component';
import { FileService } from '../../../shared/services/file.service';
import { saveAs } from 'file-saver';
import { AppConsts } from '@shared/AppConsts';

enum orderOperationType {
	Approve = 1,
	Rejected = 0
}


enum ApproveResulMessageType{

	Approved_P = 1,
	NoStock_NT = 2,
	NoRelatedBigSizeProduct_NT = 3

}

@Component({
	selector: 'kt-requests-pending-my-approval',
	templateUrl: './requests-pending-my-approval.component.html',
	styleUrls: ['./requests-pending-my-approval.component.scss']
})

export class RequestsPendingMyApprovalComponent extends AppComponentBase implements OnInit, AfterViewInit , OnDestroy {

	@ViewChild("searchInput", { static: true }) searchInput: ElementRef;
	isLoadingComponent = new BehaviorSubject<boolean>(false);
	

	nStokView: boolean = null;
	selectedProductList = [];


	isStokViewAuth: boolean = false;

	//İnfo uyarı kapama
	infoHide: boolean = true;

	btnInfoHide() {
		this.infoHide = !this.infoHide;
	}

	//numberOfDaysList = [
	//	//{ key: 0, value: "Hepsi" },
	//	{ key: 0, value: 7 },
	//	{ key: 1, value: 14 },
	//	{ key: 2, value: 21 },
	//	{ key: 3, value: 30 },
	//	{ key: 4, value: 60 },
	//	{ key: 5, value: 90 },

	//]

	approvalDateFilters = [
		//{ key: 0, value: "Hepsi" },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST7DAYS", this.localizationSourceName), value: 7 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST14DAYS", this.localizationSourceName), value: 14 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST21DAYS", this.localizationSourceName), value: 21 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST30DAYS", this.localizationSourceName), value: 30 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST60DAYS", this.localizationSourceName), value: 60 },
		{ key: this.localization.localize("FE.APPROVALS.FILTERS.DATEFILTER.PAST90DAYS", this.localizationSourceName), value: 90 },

	]

	preOrderAmount: number;

	sumDeci = new BehaviorSubject<number>(0);

	//son kaç günün listesinden seçtiği gün bilgisini tutar.
	//Mesela: son 7 gün gibi.
	selectedLastNumberDayObj;

	//Sayfa ilk yüklendiği anda getirilecek son 7 gün mesela gibi. 
	DefaultSelectedLastNumberDayObj;

	//Asenkron Test Datası
	asynTestProductlist = new BehaviorSubject<any[]>([]);
	productList = new BehaviorSubject<any[]>([]);
	filteredProductList = new BehaviorSubject<any[]>([]);

	searchKeyword = "";
	
	private subscriptions: Subscription[] = [];
	

	constructor(private modalService: NgbModal,
		private _orderService: OrderServiceProxy,
		private customLocalization: CustomLocalizationService,
		private _fileService: FileService,
		injector: Injector,
	) {
		super(injector);
	}
	ngAfterViewInit(): void {
		this.search();
	}
	ngOnInit() {

		this.isStokViewAuth = this.appSession.user.isUserStockView;

		//sayfa yüklendiği anda varsayılan seçili olarak gelmesini istediğimiz gün.
		//this.selectedLastNumberDayObj = this.numberOfDaysList[0].key;

		//Sayfa yüklendiği anda son kaç günün listesi isteniyorsa o gün sayısını barındırır.
		//this.DefaultSelectedLastNumberDayObj = this.numberOfDaysList[0];

		this.selectedLastNumberDayObj = this.approvalDateFilters[0];
		var defaultDateValue = this.approvalDateFilters[0].value;


		this.productLoadList(defaultDateValue);

		this.getCheckUserHasProductLocationOrderHistoryView();

		//this.search();
		
	}

	search(){

		const searchSubscription = fromEvent(
			this.searchInput.nativeElement,
			"keyup"
		)
			.pipe(
				debounceTime(500),
				distinctUntilChanged(),
				tap(() => {
	
					if (this.searchKeyword.replace(/\s/g, "").length < 1 && this.searchKeyword.indexOf(' ') >= 0) {
						return;
					}
	
					this.filteredProductList.next(this.searchKeyword === ""? this.productList.getValue() : this.productList.getValue().filter((element) => {

						let turkishKeyword = this.toTurkishCharacter(this.searchKeyword.toLowerCase());

						return (element.productCode.toLowerCase().includes(turkishKeyword) 
								 || this.toTurkishCharacter(element.productName.toLowerCase()).includes(turkishKeyword)
							     || this.toTurkishCharacter(element.ordererName.toLowerCase()).includes(turkishKeyword)
							     || this.toTurkishCharacter(element.toAddressName.toLowerCase()).includes(turkishKeyword));
								 //ordererName
					  }));
				}, err => {
					alert("Arama sırasında bir hata oluştu");
				})
			)
			.subscribe();
	
		this.subscriptions.push(searchSubscription);

	}

	/**
	 * Müsait bir zamanda global bir yere taşınmalıdır..
	 * @param str 
	 * @returns 
	 */
	private toTurkishCharacter(str){

		var charMap = {
			Ç: 'C',
			Ö: 'O',
			Ş: 'S',
			İ: 'I',
			I: 'i',
			Ü: 'U',
			Ğ: 'G',
			ç: 'c',
			ö: 'o',
			ş: 's',
			ı: 'i',
			ü: 'u',
			ğ: 'g'
		  };
	  
		  let str_array = str.split('');
	  
		  for (var i = 0, len = str_array.length; i < len; i++) {
			str_array[i] = charMap[str_array[i]] || str_array[i];
		  }
	  
		  str = str_array.join('');
	  
		  var clearStr = str.replace(/[^a-z0-9-.çöşüğı]/gi, "");

		  return clearStr;
	}

	// searchKey(data: string) {
	// 	this.searchText = data;
	// 	this.search();
	//   }

	//   search() {

	// 	//let filteredList : any[];

	// 	this.filteredProductList.next(this.searchText === ""? this.productList.getValue() : this.productList.getValue().filter((element) => {
	// 	  return (element.productCode.toLowerCase().includes(this.searchText.toLowerCase()) 
	// 	  		 || element.productName.toLowerCase().includes(this.searchText.toLowerCase())
	// 			 || element.ordererName.toLowerCase().includes(this.searchText.toLowerCase())
	// 			 || element.toAddressName.toLowerCase().includes(this.searchText.toLowerCase()));
	// 			   //ordererName
	// 	}));

	// 	//this.productList.next(filteredList);
	//   }

	isProductHistoryView = new BehaviorSubject<boolean>(false);

	getCheckUserHasProductLocationOrderHistoryView() {

		this._orderService.checkUserHasProductLocationOrderHistoryView()
			.subscribe(res => {
				console.log(res);
				this.isProductHistoryView.next(res);
			});
	}

	onClickBtnProductHistory(selectedProduct: OrderProductTaskDto) {


		const modalRef = this.modalService.open(ProductHistoryViewInformationComponent, { windowClass: 'dark-modal', size: 'lg' });
		modalRef.componentInstance.orderWaitingMyApprove = selectedProduct;


		modalRef.componentInstance.approvalConfirmSelected.subscribe(result => {

		

		})


	}

	// #region Çekilmek istenen gün sayını belirttiğimiz combobox işlemlerini yapıyoruz. Mesela: son 7 gün ya da son 14 gün getir bana gibi


	onSelectedNumberOfDays(numberOfDay) {

		//Bu data burak biye gönderielcek ve subscribe ile yakalanan data tekrar behaviour subject ile yakalanacak.
		//ve producrt tekrar balışmış olacak
		this.productLoadList(numberOfDay);


	}

	// #endregion

	// #region Ürün listesi yükleyici

	productLoadList(dateValue) {

		this.isLoadingComponent.next(true);
		//Burak abinin verdiği method buraya yazılacak ve extra olarak gün sayısı method içerisinde verilerek
		//productList içerisine atılacak.
		this._orderService.getWaitingForMyApprovalOrders(dateValue).subscribe(pList => {

			var numberholder = 0;

			//var filterPList = pList.filter((x) => x.isCanceledOrder == false);
			this.productList.next(pList);
			this.filteredProductList.next(pList);
			console.log(pList);
			//console.log("onayımı bekleyen talepler sayfasında yım");
			pList.forEach(obj => {
				numberholder += (+obj.productDeci) * obj.qty;
			})

			numberholder.toFixed(2);
			this.sumDeci.next(+(numberholder.toFixed(2)));


			this.isLoadingComponent.next(false);

		}, err => {

			this.isLoadingComponent.next(false);


		});

	}




	// #endregion

	// #region Hepsini seç ve seçili ürünlerin listesini tutan methodlar var



	//Hepsini şeç checkboxı tıklanıldığında diğer irin gridinde ki butonların şeçilmesini sağlar.
	checkboxSelectAll(selectProducts) {
		//pRow selectorunun içerisinde bulunduğu tüm yerleri alır. yani row ların hepsini buradan alırız.
		document.querySelectorAll('.pRow').forEach((el) => {


			//////////////////////////////////////////////////

			//Eğer Talep miktarı true ise bu adamının check hepsi seç dediğin de seçilmiyicek.
			//Yani Kulalnıcı bir işlem yaptı ve Onaylandı ya da Wms1 durumları oluşursa bunları
			//checkboxlarını seçmeyecek sadece yetersiz stok için seçebilecek

			var isOrderAmount = (el.querySelector('.orderAmount') as HTMLInputElement).disabled;
			if (!isOrderAmount) {

				//Checkbox elementine eriştik.
				let checkBox = el.querySelector('.edit-col input') as HTMLInputElement;

				if (!!checkBox) {
					//Eğer tıklanılan hepsini seç checkbox true ya false hangisi ise onu diğer checkboxların içerisine atadık.
					checkBox.checked = selectProducts.checked;
				};


			}
			//////////////////////////////////////////////////



			////Checkbox elementine eriştik.
			//let checkBox = el.querySelector('.edit-col input') as HTMLInputElement;

			//if (!!checkBox) {
			//	//Eğer tıklanılan hepsini seç checkbox true ya false hangisi ise onu diğer checkboxların içerisine atadık.
			//	checkBox.checked = selectProducts.checked;
			//}


		});

	}


	// #endregion

	// #region Toplu yani checkboxdan seçerek Kaydetme işlemleri

	//Onayla butonuna tıklandığında elementlerin içerisinde gezerek gerekli dataları yakalıyoruz.
	//Şuan ngModel ile datalarımızı yakalıyoruz üstteki yapı da bir alternatif sadece.
	btnSelectedApproveOrRejected(operationType: number) {


		//ngModel ile datalarımızı yakalıyoruz.
		let productList = this.selectedproductHolder(operationType);
		if (productList.length < 1) {
			return;
		}



		const modalRef = this.modalService.open(ProductApprovalOrRejectModalComponent, { windowClass: 'dark-modal' });
		modalRef.componentInstance.operationType = operationType;


		modalRef.componentInstance.approvalConfirmSelected.subscribe(result => {

			if (result && operationType == orderOperationType.Approve) {
				this._orderService.approveOrder(productList).subscribe((obj: OrderApprovedDto[]) => {

					this.getApproveIsCompletedStatus(obj);

				});
			}

			else if (result && operationType == orderOperationType.Rejected) {

				this._orderService.rejectOrder(productList, modalRef.componentInstance.description).subscribe(x => {

					//this.getRejectIsCanceledStatus(productList);
					this.uiMessage.modal.success("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.SUCCESSPROCESS"), () => {
						this.productLoadList(this.selectedLastNumberDayObj.value);

					});

				});

			}

		})

	}


	// #endregion


	// #region Ürün onay ya da Reddetme işlmelerinden sonra ilgili satırı bulup stok yetrsiz ya da kırmızı ,
	//yeşil gibi durumlar yakaladığımız methodlar

	//Kullanıcı bir şeyi ya da bir şeyleri onayladıktan sonra bize isCompleted diye bir değer dönüyor bu değer true
	//ise onaylanma işlemi tamam ancak false ise stok yetersiz demektir biz de burada sayfayı render etmeden anlık
	//olarak satırda gösteriyoruz
	getApproveIsCompletedStatus(obj: OrderApprovedDto[]) {


		//İşlemler bittikten sonra herşey yolundaysa ürünler stok yetersiz ya da
		// onaylandığını belirten şeyler yapıyoruz.
		document.querySelectorAll(".pList").forEach((el) => {
			let orderDetailsId = (el.querySelector('.orderDetailsId') as HTMLElement).innerText;

			obj.forEach(seletedObj => {

				//Burada ki status karşılığı onaylama başarıyla gerçekleşti ya da ürün stok yetkisi yok ise bunların checkbozlarını gizle ve gerekli yazılıarı bu rowlara yaz diyoruz.
				//Onaylanma durumunda buraya girer.
				//if (seletedObj.orderDetailsId == (+orderDetailsId) && (seletedObj.status == 1 || seletedObj.status == 3)) {
				if (seletedObj.orderDetailsId == (+orderDetailsId) && (seletedObj.status == +ApproveResulMessageType.Approved_P)) {

					el.querySelector('.approveResult').setAttribute('style', 'display: block');
					el.querySelector('.approveResult h4').setAttribute('class', seletedObj.statusStyleText);
					el.querySelector('.approveResult h4').innerHTML = seletedObj.statusText;

					(el.querySelector('.edit-col input') as HTMLInputElement).checked = false;
					(el.querySelector('.edit-col input') as HTMLInputElement).disabled = true;
					el.querySelector('.edit-col label').setAttribute('class', 'kt-checkbox  pChckbx');

					(el.querySelector('.orderAmount') as HTMLButtonElement).disabled = true;
					(el.querySelector('.btnDelete') as HTMLButtonElement).disabled = true;
					(el.querySelector('.btnApprove') as HTMLButtonElement).disabled = true;


					//(el.querySelector('.pChckbx') as HTMLInputElement).parentNode.removeChild(el.querySelector('.pChckbx'));
					//(el.querySelector('.btnApproveReject') as HTMLInputElement).parentNode.removeChild(el.querySelector('.btnApproveReject'));

					//el.querySelector('.pRow').setAttribute('style', 'pointer-events: none;');

					(el.querySelector('.livestock') as HTMLInputElement).remove();



				}
				//Burada ki Status eğer yeterli ürün yok ise buraya gir diyor.
				//else if (seletedObj.orderDetailsId == (+orderDetailsId) && seletedObj.status == 2) {
				else if (seletedObj.orderDetailsId == (+orderDetailsId) && seletedObj.status == +ApproveResulMessageType.NoStock_NT) {


					el.querySelector('.approve_P').setAttribute('style', 'display: block');
					//el.querySelector('.approve_P h4').setAttribute('class', obj.find((x) => x.orderDetailsId == (+orderDetailsId)).statusStyleText);
					el.querySelector('.approve_P h5').innerHTML = "<strong>" + this.customLocalization.l("ORDER.APPROVE.STATUS.ORDERABLESTOCK") + "</strong>" + seletedObj.orderableTotalQuantity;


					el.querySelector('.approveResult').setAttribute('style', 'display: block');
					el.querySelector('.approveResult h4').setAttribute('class', seletedObj.statusStyleText);
					el.querySelector('.approveResult h4').innerHTML = seletedObj.statusText;

					(el.querySelector('.livestock') as HTMLInputElement).remove();

				}
				//Wms1 ürün olmama durmuna buradan girer.
				//else if (seletedObj.orderDetailsId == (+orderDetailsId) && seletedObj.status == 3) {
				else if (seletedObj.orderDetailsId == (+orderDetailsId) && seletedObj.status == +ApproveResulMessageType.NoRelatedBigSizeProduct_NT) {

					//Bu üç satır sırasıyla önce yeri görünür yapar, sonra css verir ve en son mesajı basar.
					el.querySelector('.approveResult').setAttribute('style', 'display: block');
					el.querySelector('.approveResult h4').setAttribute('class', seletedObj.statusStyleText);
					el.querySelector('.approveResult h4').innerHTML = seletedObj.statusText;

					//bu iki satır checkbox ı disabled eder ve css ile bunun daha grimsi olmasını sağlar.
					(el.querySelector('.edit-col input') as HTMLInputElement).checked = false;
					(el.querySelector('.edit-col input') as HTMLInputElement).disabled = true;
					el.querySelector('.edit-col label').setAttribute('class', 'kt-checkbox  pChckbx');

					//canlı stok, iptal etme ve onaylama butonlarını disabled eder.
					(el.querySelector('.orderAmount') as HTMLButtonElement).disabled = true;
					(el.querySelector('.btnDelete') as HTMLButtonElement).disabled = true;
					(el.querySelector('.btnApprove') as HTMLButtonElement).disabled = true;
					
					//el.querySelector('.pRow').setAttribute('style', 'pointer-events: none;');
				}


			})
			
			////Burada ki status karşılığı onaylama başarıyla gerçekleşti ya da ürün stok yetkisi yok ise bunların checkbozlarını gizle ve gerekli yazılıarı bu rowlara yaz diyoruz.
			//if (!!obj.find((x) => x.orderDetailsId == (+orderDetailsId) && (x.status == 1 || x.status == 3))) {

			//	el.querySelector('.approveResult').setAttribute('style', 'display: block');
			//	el.querySelector('.approveResult h4').setAttribute('class', obj.find((x) => x.orderDetailsId == (+orderDetailsId)).statusStyleText);

			//	el.querySelector('.approveResult h4').innerHTML = obj.find((x) => x.orderDetailsId == (+orderDetailsId)).statusText;
			//	(el.querySelector('.edit-col input') as HTMLInputElement).checked = false;

			//	el.querySelector('.edit-col label').setAttribute('class', 'kt-checkbox  pChckbx');

			//	(el.querySelector('.orderAmount') as HTMLButtonElement).disabled = true;

			//	///////////////////////////
			//	(el.querySelector('.btnDelete') as HTMLButtonElement).disabled = true;
			//	(el.querySelector('.btnApprove') as HTMLButtonElement).disabled = true;


			//	//////////////////////////


			//	//(el.querySelector('.pChckbx') as HTMLInputElement).parentNode.removeChild(el.querySelector('.pChckbx'));
			//	//(el.querySelector('.btnApproveReject') as HTMLInputElement).parentNode.removeChild(el.querySelector('.btnApproveReject'));

			//	el.querySelector('.pRow').setAttribute('style', 'pointer-events: none;');

			//	(el.querySelector('.livestock') as HTMLInputElement).remove();



			//}
			////Burada ki Status eğer yeterli ürün yok ise buraya gir diyor.
			//else if (!!obj.find((x) => x.orderDetailsId == (+orderDetailsId) && x.status == 2)) {

			//	//if (!!obj.find((x) => x.orderDetailsId == (+orderDetailsId) && x.status != "Approved_P")) {

			//	el.querySelector('.approve_P').setAttribute('style', 'display: block');
			//	//el.querySelector('.approve_P h4').setAttribute('class', obj.find((x) => x.orderDetailsId == (+orderDetailsId)).statusStyleText);
			//	el.querySelector('.approve_P h5').innerHTML = "<strong>Talep Edilebilir Stok :</strong>" + obj.find((x) => x.orderDetailsId == (+orderDetailsId)).orderableTotalQuantity;

			//	//}

			//	el.querySelector('.approveResult').setAttribute('style', 'display: block');
			//	el.querySelector('.approveResult h4').setAttribute('class', obj.find((x) => x.orderDetailsId == (+orderDetailsId)).statusStyleText);
			//	el.querySelector('.approveResult h4').innerHTML = obj.find((x) => x.orderDetailsId == (+orderDetailsId)).statusText;

			//	(el.querySelector('.livestock') as HTMLInputElement).remove();

			//}

		});

	}

	//Kullanıcı bir değeri reddederse ilgili satırı kırmızıya alıp oraya tekrar talep girmesini engellilyoruz.
	//getRejectIsCanceledStatus(productList) {

	//	//İşlemler bittikten sonra herşey yolundaysa ürünler stok yetersiz ya da
	//	// onaylandığını belirten şeyler yapıyoruz.
	//	document.querySelectorAll(".pList").forEach((el) => {
	//		let orderApprovalTaskId = (el.querySelector('.orderApprovalTaskId') as HTMLElement).innerText;

	//		if (!!productList.find((x) => x.id == (+orderApprovalTaskId))) {

	//			el.querySelector('.rejectSuccess').setAttribute('style', 'display: block');

	//			(el.querySelector('.orderAmount') as HTMLButtonElement).disabled = true;
	//			(el.querySelector('.edit-col input') as HTMLInputElement).checked = false;
	//			//(el.querySelector('.edit-col input') as HTMLInputElement).disabled = false;
	//			(el.querySelector('.pChckbx') as HTMLInputElement).parentNode.removeChild(el.querySelector('.pChckbx'));
	//			(el.querySelector('.btnApproveReject') as HTMLInputElement).parentNode.removeChild(el.querySelector('.btnApproveReject'));

	//			el.querySelector('.pRow').setAttribute('style', 'pointer-events: none;');

	//		}

	//	});

	//}
	// #endregion

	// #region Sadece bir ürün için ürün onaylama  ya da reddetme işlmeleri
	btnApprovalOrRejectForAProject(operationType, product, pRow) {

		let productList = null;
		productList = this.selectedOneProductHolder(operationType, pRow);

		const modalRef = this.modalService.open(ProductApprovalOrRejectModalComponent, { windowClass: 'dark-modal' });
		modalRef.componentInstance.operationType = operationType;

		modalRef.componentInstance.approvalConfirmSelected.subscribe(result => {

			if (result && operationType == orderOperationType.Approve) {

				this._orderService.approveOrder(productList).subscribe(obj => {

					this.getApproveIsCompletedStatus(obj);

					console.log("onaylama işlemini yaptım" + obj);
				});
			}

			else if (result && operationType == orderOperationType.Rejected) {

				this._orderService.rejectOrder(productList, modalRef.componentInstance.description).subscribe(x => {

					//this.getRejectIsCanceledStatus(productList);
					this.uiMessage.modal.success("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.SUCCESSPROCESS"), () => {

						this.productLoadList(this.selectedLastNumberDayObj.value);
					})
				});

			}

		})

	}

	// #endregion

	// #region Talep miktarı İşlemleri Mesela: Kullanıcı bir tane talep tıklarsa eski değeri tutuyoruz ya da değiştirirse kontrol ediyoruz gibi

	//Kullancının talep miktarına her tıklayıp çıktığında bu method ile yapılan değişikliği kontrol ediyoruz.
	onChangeOrderAmount(orderAmount) {

		let orderAmountResult = this.orderAmountControl(orderAmount);

		return;
	}

	//Kullanıcı bir talep miktarını değiştirmek isterse burada kontrol ediyoruz eğer sayı uygun bir rakam değilse giremez.
	orderAmountControl(orderAmount) {

		var isOrderAmount = null;

		if (!orderAmount.value) {

			orderAmount.value = this.preOrderAmount;
			this.uiMessage.modal.error("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.INCORRECTPROCESS"), null);
			return isOrderAmount = true;
		}
		else if (orderAmount.value < 1) {
			orderAmount.value = this.preOrderAmount;
			this.uiMessage.modal.error("", this.customLocalization.l("FE.APPROVALS.TABS.WAITINGFORAPPROVAL.ALERTMESSAGES.COMMON.MINNUMBER"), null);

			return isOrderAmount = true;

		}
		else if (orderAmount.value > 5000) {
			orderAmount.value = this.preOrderAmount;
			this.uiMessage.modal.error("", this.customLocalization.l("FE.ALERTMESSAGES.COMMON.MAXNUMBER"), null);
			return isOrderAmount = true;

		}

		return isOrderAmount = false;

	}

	//Kullanıcı talep miktarı textboxına tıkladığı anda ki talep miktarı saklamak için bu methodu kullanıyoruz.
	onClickOrderAmount(orderAmount) {
		console.log(orderAmount.value);
		this.preOrderAmount = orderAmount.value;
	}


	// #endregion

	// #region seçili olan ürün listesini yakaladığımız method mesela: checkboc içerisinde seçilen ve true yaılanları alır

	//seçilen ürünleri bir tane listede tutmak için kullanıyoruz.
	//bu method sadece ikinci bir alternatif elementi yakalıyorak checkbox da checked olan dataları yakalıyoruz.
	selectedproductHolder(operationType) {

		this.selectedProductList = [];

		if (operationType == orderOperationType.Approve) {

			//pRow selectorunun içerisinde bulunduğu tüm yerleri alır. yani row ların hepsini buradan alırız.
			document.querySelectorAll('.pRow').forEach((el) => {

				//Checkbox elementine eriştik.
				let checkbox = el.querySelector('.edit-col input') as HTMLInputElement;

				//Eğer tıklanılan hepsini seç checkbox true ya false hangisi ise onu diğer checkboxların içerisine atadık.
				if (!!checkbox && checkbox.checked) {


					let orderDetailsId = (el.querySelector('.orderDetailsId') as HTMLElement).innerText;
					let twinOrderDetailsId = (el.querySelector('.twinOrderDetailsId') as HTMLElement).innerText;
					let approvedQty = (el.querySelector('.orderAmount') as HTMLInputElement).value;
					let productId = (el.querySelector('.productId') as HTMLElement).innerText;
					let variationId = (el.querySelector('.variationId') as HTMLElement).innerText;

					console.log(productId + " " + variationId);

					this.selectedProductList.push({
						OrderDetailsId: +orderDetailsId,
						TwinOrderDetailsId: +twinOrderDetailsId,
						Quantity: +approvedQty,
						ProductId: +productId,
						VariationId: +variationId
					});

				}


			});

		}
		else {
			//pRow selectorunun içerisinde bulunduğu tüm yerleri alır. yani row ların hepsini buradan alırız.
			document.querySelectorAll('.pRow').forEach((el) => {

				//Checkbox elementine eriştik.
				let checkbox = el.querySelector('.edit-col input') as HTMLInputElement;

				//Eğer tıklanılan hepsini seç checkbox true ya false hangisi ise onu diğer checkboxların içerisine atadık.
				if (!!checkbox && checkbox.checked) {


					let orderApprovalTaskId = (el.querySelector('.orderApprovalTaskId') as HTMLElement).innerText;
					//let twinOrderApprovalTaskId = (el.querySelector('.twinOrderApprovalTaskId') as HTMLElement).innerText;

					this.selectedProductList.push(+orderApprovalTaskId);

				}


			});
		}


		return this.selectedProductList;

	}

	// #endregion


	// #region seçilmiş olan tek ürünü yani bireysel ürünü alır 


	//Seçilmiş olan ürünü alıyoruz ve gerekli dataları yakalama işlemini yaptırıyoruz.
	selectedOneProductHolder(operationType, pRow) {

		this.selectedProductList = [];

		if (operationType == orderOperationType.Approve) {

			let orderDetailsId = (pRow.querySelector('.orderDetailsId') as HTMLElement).innerText;
			let twinOrderDetailsId = (pRow.querySelector('.twinOrderDetailsId') as HTMLElement).innerText;
			let approvedQty = (pRow.querySelector('.orderAmount') as HTMLInputElement).value;


			let productId = (pRow.querySelector('.productId') as HTMLElement).innerText;
			let variationId = (pRow.querySelector('.variationId') as HTMLElement).innerText;
			console.log(productId + " " + variationId);

			this.selectedProductList.push({
				OrderDetailsId: +orderDetailsId,
				TwinOrderDetailsId: +twinOrderDetailsId,
				Quantity: +approvedQty,
				ProductId: +productId,
				VariationId: +variationId
			});

		}
		else {

			let orderApprovalTaskId = (pRow.querySelector('.orderApprovalTaskId') as HTMLElement).innerText;
			//let twinOrderApprovalTaskId = (pRow.querySelector('.twinOrderApprovalTaskId') as HTMLElement).innerText;

			this.selectedProductList.push(+orderApprovalTaskId);


		}

		return this.selectedProductList;

	}

	// #endregion

	//Fotoğrafların url döndermek için kullanıyoruz.
	getPhotoUrl(kod: string): string {
		return  AppConsts.productImage.url + '/' + kod + '.jpg'
	}

	//Product listesinin üzerinde ki resimlere tıklayınca buradan code göre url oluşturup modal açıp içine basıyoruz.
	openImage(productCode, pName) {

		let imgActualSize = ( AppConsts.productImage.url + '/' + productCode + '.jpg');

		const modalRef = this.modalService.open(ImageModalComponent, {
			size: 'md'
		});

		modalRef.componentInstance.imgActualSize = imgActualSize;
		modalRef.componentInstance.productCode = productCode;
		modalRef.componentInstance.productName = pName;
	}

	/**
	 * Onay Beykleyen talepler listesini excele aktarir.
	 * @param isWithPhoto 
	 */
	btnExportToExcel(isWithPhoto: boolean){
			
			this._orderService.getWaitingForApprovalOrdersForExcel(isWithPhoto, this.selectedLastNumberDayObj.value).subscribe(res => {
			
				var blob = this._fileService.base64toBlob(res.base64, res.fileType);
				const file = new File([blob], res.fileName, { type: res.fileType });
	
				saveAs(file);
			});
	}

	ngOnDestroy() {

		// this.subscriptions.unsubscribe();

		//this.selectedLastNumberDayObj = this.numberOfDaysList[1].key;
		this.subscriptions.forEach(item => {
			item.unsubscribe();
		});
	}

}

